// Axios
import { AxiosResponse } from "axios";
import { _axios } from "../../../Base_Axios_Config/_axios";
// Axios

// Models
import {
  I_Message,
  I_ProcessActivitySteps,
} from "../../../../Models/interfaces";
// Models

export const getProcessActivityStepsService = (_data: {
  userToken: string;
  _data: {
    processInstanceId: string;
    stepNumber: string | number;
    size: string | number;
  };
}): Promise<
  AxiosResponse<{
    error: number;
    messages: I_Message[];
    result: I_ProcessActivitySteps;
  }>
> => {
  return _axios.get(
    `/processes/running-instances/${_data._data.processInstanceId}/history/steps?step=${_data._data.stepNumber}&size=${_data._data.size}`,
    {
      headers: {
        Authorization: `Bearer ${_data.userToken}`,
      },
    }
  );
};
